import { api } from './client';

export interface ClosingPeriod {
  id: string;
  organization_id: string;
  period_year: number;
  period_month: number;
  is_closed: boolean;
  closed_at: string | null;
  closed_by: string | null;
}

export interface ClosingPreviewLine {
  account_code: string;
  account_name: string;
  side: 'income' | 'expense';
  amount: string;
}

export interface ClosingPreview {
  organization_id: string;
  period_year: number;
  period_month: number;
  is_closed: boolean;
  income_lines: ClosingPreviewLine[];
  expense_lines: ClosingPreviewLine[];
  total_income: string;
  total_expenses: string;
  financial_result: string;
}

export interface CloseMonthResult {
  period_id: string;
  total_income: number;
  total_expenses: number;
  financial_result: number;
}

export const closing = {
  listPeriods: (organizationId: string, year?: number) =>
    api.get<ClosingPeriod[]>('/closing/months', {
      params: { organization_id: organizationId, year },
    }).then((r) => r.data),
  preview: (organizationId: string, year: number, month: number) =>
    api.get<ClosingPreview>(`/closing/preview/${year}/${month}`, {
      params: { organization_id: organizationId },
    }).then((r) => r.data),
  close: (organizationId: string, year: number, month: number) =>
    api.post<CloseMonthResult>(
      `/closing/close/${year}/${month}`,
      null,
      { params: { organization_id: organizationId } },
    ).then((r) => r.data),
  reopen: (organizationId: string, year: number, month: number) =>
    api.post<void>(
      `/closing/reopen/${year}/${month}`,
      null,
      { params: { organization_id: organizationId } },
    ).then(() => undefined),
};
